/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import { NavLink as Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import SelectLanguage from "./components/SelectLanguage/SelectLanguage";
import i18n from "./translation/i18n";
import { getQrGuestFlowTraceId } from "./utils/qrGuestFlowTrace";
import { hasActiveGuestMergeIntent } from "./utils/constant";
import {
  PRODUCT_ROUTES,
  getRedesignContent
} from "./redesign/content";
import { OutlineIcon } from "./redesign/RedesignIcons";
import { filterProductRoutesForLanguage } from "./shared/productLocalePolicy";
import { getStaticRoutePaths } from "./shared/staticRoutePaths";
import { toLocalHref } from "./shared/clientLocale";
import {
  getScanQrPageContent,
  SCAN_QR_PAGE_PATH
} from "./shared/scanQrPageContent";

const accountServer =
  typeof window !== "undefined" ? window.QRCODE_ENV?.ACCOUNT_SERVICE : "";
const qrocdeManagementUrl =
  typeof window !== "undefined"
    ? window.QRCODE_ENV?.QRCODE_MANAGEMENT || "https://manager.qrcode-gen.com"
    : "https://manager.qrcode-gen.com";
const initialState = {
  shouldShowPromotionBanner: false,
  currentLanguage: i18n.language || 'en', // Lưu trữ ngôn ngữ hiện tại
  productsOpen: false,
  resourcesOpen: false,
  mobileMenuOpen: false,
};
export class Navbar_main extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.handleLoginClick = this.handleLoginClick.bind(this);
    this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
    this.handleRegisterClick = this.handleRegisterClick.bind(this);
    this.handleOverlayFullClick = this.handleOverlayFullClick.bind(this);
    this.productMenuRef = React.createRef();
    this.resourcesMenuRef = React.createRef();
    this.menuToggleRef = React.createRef();
  }


  componentDidMount() {
    // Theo dõi sự thay đổi ngôn ngữ từ i18n
    i18n.on('languageChanged', this.handleLanguageChanged);
    document.addEventListener("mousedown", this.handleProductMenuDocumentClick);
    document.addEventListener("keydown", this.handleProductMenuKeyDown);
    
    // Đảm bảo trạng thái hiện tại phản ánh ngôn ngữ hiện tại
    this.setState({ currentLanguage: i18n.language });
  }
  
  componentDidUpdate(_previousProps, previousState) {
    if (previousState.mobileMenuOpen !== this.state.mobileMenuOpen) {
      if (this.state.mobileMenuOpen) {
        this.previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
      } else {
        this.restoreBodyScroll();
      }
    }
  }

  restoreBodyScroll = () => {
    if (this.previousBodyOverflow !== undefined) {
      document.body.style.overflow = this.previousBodyOverflow;
      this.previousBodyOverflow = undefined;
    }
  };

  closeMobileMenu = () => {
    this.setState({ mobileMenuOpen: false, productsOpen: false, resourcesOpen: false });
  };

  toggleMobileMenu = () => {
    this.setState((state) => ({ mobileMenuOpen: !state.mobileMenuOpen, productsOpen: false, resourcesOpen: false }));
  };

  handleMobileNavigation = (event) => {
    if (event.target.closest("a[href]")) this.closeMobileMenu();
  };

  componentWillUnmount() {
    this.restoreBodyScroll();
    // Loại bỏ listener khi component unmount
    i18n.off('languageChanged', this.handleLanguageChanged);
    document.removeEventListener("mousedown", this.handleProductMenuDocumentClick);
    document.removeEventListener("keydown", this.handleProductMenuKeyDown);
  }
  
  // Xử lý khi ngôn ngữ thay đổi
  handleLanguageChanged = (lang) => {
    console.log('Ngôn ngữ đã thay đổi trong Navbar:', lang);
    this.setState({ currentLanguage: lang });
    // Force re-render khi ngôn ngữ thay đổi
    this.forceUpdate();
  }

  handleProductMenuDocumentClick = (event) => {
    const nextState = {};
    if (
      this.state.productsOpen &&
      this.productMenuRef.current &&
      !this.productMenuRef.current.contains(event.target) &&
      !event.target.closest(".menu-product-item")
    ) {
      nextState.productsOpen = false;
    }
    if (
      this.state.resourcesOpen &&
      this.resourcesMenuRef.current &&
      !this.resourcesMenuRef.current.contains(event.target) &&
      !event.target.closest(".menu-resources-item")
    ) {
      nextState.resourcesOpen = false;
    }
    if (Object.keys(nextState).length) {
      this.setState(nextState);
    }
  };

  handleProductMenuKeyDown = (event) => {
    if (event.key === "Escape") {
      const wasMobileOpen = this.state.mobileMenuOpen;
      this.closeMobileMenu();
      if (wasMobileOpen) this.menuToggleRef.current?.focus();
    }
  };

  handleProductMenuToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.supportsProductMenuHover()) {
      this.setState({ productsOpen: true, resourcesOpen: false });
      return;
    }
    this.setState((state) => ({
      productsOpen: !state.productsOpen,
      resourcesOpen: false,
    }));
  };

  supportsProductMenuHover = () =>
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  handleProductMenuMouseEnter = () => {
    if (this.supportsProductMenuHover()) {
      this.setState({ productsOpen: true, resourcesOpen: false });
    }
  };

  handleProductMenuMouseLeave = () => {
    if (this.supportsProductMenuHover()) {
      this.setState({ productsOpen: false });
    }
  };

  handleProductMenuClose = () => {
    this.setState({ productsOpen: false });
  };

  handleResourcesMenuToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.supportsProductMenuHover()) {
      this.setState({ resourcesOpen: true, productsOpen: false });
      return;
    }
    this.setState((state) => ({
      resourcesOpen: !state.resourcesOpen,
      productsOpen: false,
    }));
  };

  handleResourcesMenuMouseEnter = () => {
    if (this.supportsProductMenuHover()) {
      this.setState({ resourcesOpen: true, productsOpen: false });
    }
  };

  handleResourcesMenuMouseLeave = () => {
    if (this.supportsProductMenuHover()) {
      this.setState({ resourcesOpen: false });
    }
  };

  handleResourcesMenuClose = () => {
    this.setState({ resourcesOpen: false });
  };

  handleChangeLanguage() {
    this.props.i18n.changeLanguage(this.props.i18n.language === "vi" ? "en" : "vi");
  }

  handleLoginClick() {
    const { language } = this.props.i18n
    window.open(this.buildLoginUrl(language), '_self');
  }

  handleRegisterClick() {
    const { language } = this.props.i18n
    window.open(this.buildRegisterUrl(language), '_self');
  }

  hasPendingGuestMerge() {
    return hasActiveGuestMergeIntent();
  }

  buildManagerAuthRedirectUrl(language) {
    // IMPORTANT:
    // Account service luôn append `?sid=...` vào redirect callback.
    // Nếu callback đã có query thì rất dễ bị redirect loop.
    const baseRedirect = `${qrocdeManagementUrl}/auth`;
    if (!this.hasPendingGuestMerge()) {
      return baseRedirect;
    }
    const hashParams = new URLSearchParams();
    hashParams.set("guest_merge", "1");
    const traceId = getQrGuestFlowTraceId();
    if (traceId) {
      hashParams.set("guest_request_id", traceId);
    }
    return `${baseRedirect}#${hashParams.toString()}`;
  }

  buildLoginUrl(inputLanguage) {
    const language = inputLanguage || this.props?.i18n?.language || this.state?.currentLanguage || "en";
    const redirect = encodeURIComponent(this.buildManagerAuthRedirectUrl(language));
    return `${accountServer}/login?context=qrcode-app&lng=${language}&redirect=${redirect}`;
  }

  buildRegisterUrl(inputLanguage) {
    const language = inputLanguage || this.props?.i18n?.language || this.state?.currentLanguage || "en";
    const redirect = encodeURIComponent(this.buildManagerAuthRedirectUrl(language));
    return `${accountServer}/signup?context=qrcode-app&lng=${language}&redirect=${redirect}`;
  }

  handleOverlayFullClick() {
    this.closeMobileMenu();
  }

  onLoginSuccess = () => {
    this.setState(this.state);
  };

  onUnauthPopupClose = () => {
    this.setState({
      openUnauthPopup: false,
      unauthPopupAnchorEl: null,
    });
  };

  onQRCodeManagementClick = () => {
    // if (!this.props.auth.isAuthenticated()) {
    //   this.setState({
    //     openUnauthPopup: true,
    //     unauthPopupAnchorEl: $("#qrcode-management-btn")[0],
    //     unAuthAnchorHrz: "left",
    //     unAuthTransformHrz: "center",
    //   });
    //   return;
    // } else window.location.href = `${qrocdeManagementUrl}/auth?id=${auth.getSession('qc_uid')}&token=${auth.getSession('qc_act')}` // history.push("/dashboard");
    window.open(qrocdeManagementUrl, "_self");
  };

  render() {
    const { t } = this.props;
    const { currentLanguage } = this.state;
    const registerUrl = this.buildRegisterUrl();
    const loginUrl = this.buildLoginUrl();
    const redesignContent = getRedesignContent(currentLanguage);
    const staticRoutes = getStaticRoutePaths(currentLanguage);
    const visibleProductRoutes = filterProductRoutesForLanguage(
      PRODUCT_ROUTES,
      currentLanguage
    );
    const scanPage = getScanQrPageContent(currentLanguage);
    const scanPageIsLocalized = Boolean(scanPage);
    const scanProductMenuItem = {
      // Từng gắn query cache-buster (v=localized-…) để né 301 sang EN bị trình duyệt cache trên các subdomain
      // ngôn ngữ cũ; từ 21/09/2026 subdomain đã 301 về apex nên bỏ (23/09/2026), link sạch = canonical.
      path: SCAN_QR_PAGE_PATH,
      label: scanPageIsLocalized
        ? scanPage.breadcrumb
        : "Scan QR Code online",
      icon: "search",
    };
    const resourceMenuItems = [
      {
        path: "/document",
        label: t('navbar.menu-right.document'),
        icon: "file",
      },
      {
        path: "/use-cases",
        label: t('navbar.menu-right.use-case'),
        icon: "briefcase",
      },
      {
        path: "/help",
        label: t('navbar.menu-right.help'),
        icon: "qrcode",
      },
    ];
    
    return (
      <div className="container-navbar">
        {this.state.shouldShowPromotionBanner && (
          <a
            className="promotion-link"
            href="https://www.ninequiz.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://www.ninequiz.com/static/media/logo.d1fd6936.svg"
              alt=""
            />
            <span className="large">
              Phần mềm tạo và quản lý kiểm tra trực tuyến, lớp học online đơn
              giản và dễ sử dụng, miễn phí vĩnh viễn.
            </span>
            <span className="small">Quản lý lớp học online.</span>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={this.handleDismissPromotionBanner}
            >
              <span aria-hidden="true">×</span>
            </button>
          </a>
        )}
        <div
          className={`overlay-full ${this.state.mobileMenuOpen ? "open" : ""}`}
          id="overlay-full"
          onClick={this.handleOverlayFullClick}
        ></div>
        <div className="header">
          <div className="row">
            <div className="col-md-12 header-flex">
              <div className="logo">
                <Link to="/">
                  <img
                    src="/images/logo-qrcode-gen-web.png"
                    alt="logo"
                    width="40"
                    height="32"
                  />
                </Link>
                <Link to="/" className="text-bold desktop-menu">
                  QRCODE-GEN
                </Link>
              </div>
              <div className="mobile-flex-menu"></div>
              {/* <div className={`user-area ${this.props.shouldShowTheButton && `user-area-with-the-button`}`}> */}
              <div className="menu-area">
                <div
                  className={`menu-area-product ${this.state.productsOpen ? "is-open" : ""}`}
                  ref={this.productMenuRef}
                  onMouseEnter={this.handleProductMenuMouseEnter}
                  onMouseLeave={this.handleProductMenuMouseLeave}
                >
                  <button
                    type="button"
                    className="menu-area-product-button"
                    aria-haspopup="true"
                    aria-expanded={this.state.productsOpen}
                    aria-controls="desktop-product-menu"
                    onClick={this.handleProductMenuToggle}
                  >
                    {redesignContent.nav.products}
                    <i className="fa fa-angle-down" aria-hidden="true" />
                  </button>
                  <div
                    id="desktop-product-menu"
                    className="menu-area-product-popover"
                    role="menu"
                    aria-hidden={!this.state.productsOpen}
                  >
                    <div className="menu-area-product-title">
                      {redesignContent.nav.productsHint}
                    </div>
                    {scanProductMenuItem && (
                      <a
                        href={toLocalHref(scanProductMenuItem.path)}
                        role="menuitem"
                        onClick={this.handleProductMenuClose}
                        tabIndex={this.state.productsOpen ? 0 : -1}
                      >
                        <span className="menu-area-product-icon" aria-hidden="true">
                          <OutlineIcon name={scanProductMenuItem.icon} size={18} />
                        </span>
                        <span>{scanProductMenuItem.label}</span>
                        <i className="fa fa-angle-right menu-area-product-arrow" aria-hidden="true" />
                      </a>
                    )}
                    {visibleProductRoutes.map((product) => (
                      <Link
                        key={product.key}
                        to={product.path}
                        role="menuitem"
                        onClick={this.handleProductMenuClose}
                        tabIndex={this.state.productsOpen ? 0 : -1}
                      >
                        <span className="menu-area-product-icon" aria-hidden="true">
                          <OutlineIcon name={product.icon} size={18} />
                        </span>
                        <span>{redesignContent.pages[product.key].navLabel}</span>
                        <i className="fa fa-angle-right menu-area-product-arrow" aria-hidden="true" />
                      </Link>
                    ))}
                  </div>
                </div>
                <Link to={staticRoutes.whatIsQr}>{t('navbar.menu-right.what-is-qrcode')}</Link>
                <a href={toLocalHref(staticRoutes.servicePack)}>{t('navbar.menu-right.package')}</a>
                <div
                  className={`menu-area-product menu-area-resources ${this.state.resourcesOpen ? "is-open" : ""}`}
                  ref={this.resourcesMenuRef}
                  onMouseEnter={this.handleResourcesMenuMouseEnter}
                  onMouseLeave={this.handleResourcesMenuMouseLeave}
                >
                  <button
                    type="button"
                    className="menu-area-product-button"
                    aria-haspopup="true"
                    aria-expanded={this.state.resourcesOpen}
                    aria-controls="desktop-resources-menu"
                    onClick={this.handleResourcesMenuToggle}
                  >
                    {t('navbar.menu-right.resources')}
                    <i className="fa fa-angle-down" aria-hidden="true" />
                  </button>
                  <div
                    id="desktop-resources-menu"
                    className="menu-area-product-popover menu-area-resources-popover"
                    role="menu"
                    aria-hidden={!this.state.resourcesOpen}
                  >
                    {resourceMenuItems.map((item) => (
                      <Link
                        key={item.path}
                        to={item.path}
                        role="menuitem"
                        onClick={this.handleResourcesMenuClose}
                        tabIndex={this.state.resourcesOpen ? 0 : -1}
                      >
                        <span className="menu-area-product-icon" aria-hidden="true">
                          <OutlineIcon name={item.icon} size={18} />
                        </span>
                        <span>{item.label}</span>
                        <i className="fa fa-angle-right menu-area-product-arrow" aria-hidden="true" />
                      </Link>
                    ))}
                  </div>
                </div>
                <Link to="/blog">{t('navbar.menu-right.news')}</Link>
                <Link to={staticRoutes.contact}>{t('navbar.menu-right.contact')}</Link>
              </div>
              <div className="user-area">
                <SelectLanguage
                  allowReload={true}
                  className="container-select-lang header-language desktop-menu"
                />
                {/* <button
                  id="qrcode-management-btn"
                  onClick={this.onQRCodeManagementClick}
                  className="btn btn-default save-button"
                >
                  Quản lý QR Code
                </button> */}
                {/* Temporarily hide Scan QR button */}
                <button className="btn btn-default auth-area header-auth">
                  <span
                    className="register"
                    onClick={this.handleRegisterClick}
                  >
                    {t('navbar.signup')}
                  </span>
                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                  <span
                    className="login"
                    onClick={this.handleLoginClick}
                  >
                    {t('navbar.signin')}
                    {/* Đăng nhập */}
                  </span>
                </button>
                {/* <SelectLanguage/> */}

              </div>
              {/* Solution 1: */}
              {/* {window.location.pathname === '/what-is-qr-code' && ( */}
              {/* Solution 2: */}
              <button type="button" ref={this.menuToggleRef}
                className={`toggle-menu ${this.state.mobileMenuOpen ? "open" : ""}`}
                aria-expanded={this.state.mobileMenuOpen} aria-controls="mobile-navigation"
                onClick={this.toggleMobileMenu}>
                <b className="toggle-menu-label">{t('navbar.menu')}</b>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </div>

        {/* <div className="toggle-menu">
                    <label>Menu</label>
                    <span></span>
                    <span></span>
                </div> */}

        <div className="nav-right">
          <div id="mobile-navigation" className={`menu-right ${this.state.mobileMenuOpen ? "open" : ""}`}
            aria-hidden={!this.state.mobileMenuOpen} onClick={this.handleMobileNavigation}>
            <ul>
              <li>
                <Link to="/">{t('navbar.menu-right.homepage')}</Link>
              </li>
              <li className={`menu-product-item ${this.state.productsOpen ? "is-open" : ""}`}>
                <button
                  type="button"
                  className="menu-product-toggle"
                  aria-expanded={this.state.productsOpen}
                  onClick={this.handleProductMenuToggle}
                >
                  {redesignContent.nav.products}
                  <i className="fa fa-angle-down" aria-hidden="true" />
                </button>
                <ul className="menu-product-submenu">
                  {scanProductMenuItem && (
                    <li>
                      <a
                        href={toLocalHref(scanProductMenuItem.path)}
                        onClick={this.handleProductMenuClose}
                      >
                        <span className="menu-product-submenu-icon" aria-hidden="true">
                          <OutlineIcon name={scanProductMenuItem.icon} size={16} />
                        </span>
                        {scanProductMenuItem.label}
                      </a>
                    </li>
                  )}
                  {visibleProductRoutes.map((product) => (
                    <li key={product.key}>
                      <Link to={product.path} onClick={this.handleProductMenuClose}>
                        <span className="menu-product-submenu-icon" aria-hidden="true">
                          <OutlineIcon name={product.icon} size={16} />
                        </span>
                        {redesignContent.pages[product.key].navLabel}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              <li>
                <Link to={staticRoutes.whatIsQr}>{t('navbar.menu-right.what-is-qrcode')}</Link>
              </li>
              <li>
                <a href={toLocalHref(staticRoutes.servicePack)}>{t('navbar.menu-right.package')}</a>
              </li>

              <li className={`menu-product-item menu-resources-item ${this.state.resourcesOpen ? "is-open" : ""}`}>
                <button
                  type="button"
                  className="menu-product-toggle"
                  aria-expanded={this.state.resourcesOpen}
                  onClick={this.handleResourcesMenuToggle}
                >
                  {t('navbar.menu-right.resources')}
                  <i className="fa fa-angle-down" aria-hidden="true" />
                </button>
                <ul className="menu-product-submenu">
                  {resourceMenuItems.map((item) => (
                    <li key={item.path}>
                      <Link to={item.path} onClick={this.handleResourcesMenuClose}>
                        <span className="menu-product-submenu-icon" aria-hidden="true">
                          <OutlineIcon name={item.icon} size={16} />
                        </span>
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              <li>
                <Link to="/blog">{t('navbar.menu-right.news')}</Link>
                {/* <a style={{ pointerEvents: 'none' }}>{t('navbar.menu-right.news')}</a> */}
              </li>
              <li>
                <Link to={staticRoutes.contact}>{t('navbar.menu-right.contact')}</Link>
              </li>
              <li className="mobile-menu">
                <a
                  href={registerUrl}
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleRegisterClick();
                  }}
                >
                  {t('navbar.signup')}
                </a>
              </li>
              <li className="mobile-menu">
                <a
                  href={loginUrl}
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleLoginClick();
                  }}
                >
                  {t('navbar.signin')}
                </a>
              </li>
              <li className="mobile-menu menu-language-item">
                <SelectLanguage
                  allowReload={true}
                  className="menu-language-select"
                />
              </li>
            </ul>
          </div>
        </div>
        <div className={`sticky-footer ${this.state.mobileMenuOpen ? "open" : ""}`}
          aria-hidden={!this.state.mobileMenuOpen} onClick={this.handleMobileNavigation}>
          <div className="row">
            <div className="col-md-3 col-sm-6 col-xs-12 section-social">
              <ul className="social-footer">
                <li>
                  <a href="https://qrcode-gen.com/" target="_blank" rel="noopener noreferrer">
                    QRCODE-GEN.
                  </a>
                </li>
                <li>&nbsp;{t('navbar.menu-right.ninecode-jsc\'-products')}</li>
              </ul>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <ul className="pages">
                <li>
                  <Link to="/">{t('navbar.menu-right.homepage')}</Link>
                </li>
                <li>
                  <a href={staticRoutes.terms}>{t('navbar.menu-right.term-of-use')}</a>
                </li>
                <li>
                  <a href={staticRoutes.privacy}>{t('footer.usage-policy')}</a>
                </li>
              </ul>
            </div>
            <div className={`col-md-3 col-sm-6 col-xs-12 section-mailto ${this.state.mobileMenuOpen ? "open" : ""}`}>
              <div className="mailto">
                <i className="fa fa-envelope" aria-hidden="true"></i>
                <a href="mailto:info@ninecode.vn">
                  {t('navbar.menu-right.mail')}
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }

  handleDismissPromotionBanner = (e) => {
    e.preventDefault();
    this.setState({
      shouldShowPromotionBanner: false,
    });
  };
}

export default withTranslation(undefined, { withRef: true })(Navbar_main);
